import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../../../../App";
import SoftSelect from "../../../../../../components/SoftSelect";
import { getManagers, validateManagerPin } from "../../../../../../config/Services";
import Navbar from "../../../../posnavbar/Navbar";
import { getmangerPin, getmangeruidx } from "../../../all-products/redux/Reducers/sessionReducer";
import { getDeviceType } from "../../../all-products/redux/Reducers/paginationReducer";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import useGetDevice from "../../../hooks/useGetDevice";
import usePrint from "../../../hooks/usePrint";
import useWeighingItemModal from "../../../hooks/useWeighingItemModal";
import { emit } from "react-native-react-bridge/lib/web";
import AppList from "./AppList";
import "./index.css";

const optiondata = [
  { value: "All", label: "All" },
  { value: "Thermal Printer", label: "Thermal Printer" },
  { value: "Pallet", label: "Pallet" },
  { value: "Accounting and Finance", label: "Accounting and Finance" },
  { value: "Payments", label: "Payments" },
  { value: "Pallet Hyperlocal", label: "Pallet Hyperlocal" },
  { value: "Marketing", label: "Marketing" },
  { value: "Billing", label: "Billing" },
  { value: "Logistics", label: "Logistics" },
  { value: "Google Merchant Center", label: "Google Merchant Center" },
];

const getDeviceIcon = (device) => {
  const categories = device?.category || [];
  if (categories.includes("Weighing Scale")) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-scale w-5 h-5"
        aria-hidden="true"
      >
        <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
        <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
        <path d="M7 21h10"></path>
        <path d="M12 3v18"></path>
        <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"></path>
      </svg>
    );
  }
  if (categories?.includes("Label Printer")) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-tag w-5 h-5"
        aria-hidden="true"
      >
        <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path>
        <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle>
      </svg>
    );
  }
  if (categories?.includes("Thermal Printer")) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-printer w-5 h-5"
        aria-hidden="true"
      >
        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
        <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
        <rect x="6" y="14" width="12" height="8" rx="1"></rect>
      </svg>
    );
  }
  if (categories?.includes("Cash Drawer")) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-inbox w-5 h-5"
        aria-hidden="true"
      >
        <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline>
        <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
      </svg>
    );
  }
  if (
    categories?.includes("Payment terminal") ||
    categories?.includes("Payments") ||
    categories?.includes("EDC Terminal")
  ) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-credit-card w-5 h-5"
        aria-hidden="true"
      >
        <rect width="20" height="14" x="2" y="5" rx="2"></rect>
        <line x1="2" x2="22" y1="10" y2="10"></line>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-printer w-5 h-5"
      aria-hidden="true"
    >
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
      <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
      <rect x="6" y="14" width="12" height="8" rx="1"></rect>
    </svg>
  );
};

const ConnectionTypeIcon = ({ type }) => {
  if (type === "USB") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="10" cy="7" r="1"></circle>
        <circle cx="4" cy="20" r="1"></circle>
        <path d="M4.7 19.3 19 5"></path>
        <path d="m21 3-3 1 2 2Z"></path>
        <path d="M9.26 7.68 5 12l2 5"></path>
        <path d="m10 14 5 2 3.5-3.5"></path>
        <path d="m18 12 1-1 1 1-1 1Z"></path>
      </svg>
    );
  }
  if (type === "Serial Port") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="16" y="16" width="6" height="6" rx="1"></rect>
        <rect x="2" y="16" width="6" height="6" rx="1"></rect>
        <rect x="9" y="2" width="6" height="6" rx="1"></rect>
        <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"></path>
        <path d="M12 12V8"></path>
      </svg>
    );
  }
  if (type === "Bluetooth") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="m7 7 10 10-5 5V2l5 5L7 17"></path>
      </svg>
    );
  }
  return null;
};

const getConnectionTypes = (urlName) => {
  switch (urlName) {
    case "thermal-posiflex":
      return ["USB", "Serial Port"];
    case "thermal-tvs":
      return ["USB", "Serial Port"];
    case "thermal-shreyans":
      return ["Bluetooth"];
    case "tvs-label-printer":
      return ["USB"];
    case "weighing-scale":
      return ["USB"];
    default:
      return [];
  }
};

const getConfigOption = (urlName, connectionType) => {
  if (urlName === "thermal-posiflex") {
    if (connectionType === "USB") {
      return {
        value: "posiflex-usb",
        label: "USB port",
        printer: "Posiflex",
        instructions: (
          <ul>
            <li>Connect the printer to the USB port of the POSIFLEX terminal</li>
            <li>
              Install Zadig from this{" "}
              <a
                href="https://github.com/pbatard/libwdi/releases/download/v1.5.0/zadig-2.8.exe"
                target="_blank"
                rel="noopener noreferrer"
              >
                link
              </a>
            </li>
            <li>Open the application. From Options -&gt; List All Devices</li>
            <img src="https://i.imgur.com/YSHxVZQ.png" alt="configure-img1" width="100%" />
            <li>
              From the list, identify your printer. Make sure &apos;WinUSB&apos; is selected from
              the target driver option below. Click Replace Driver.
            </li>
            <img src="https://i.imgur.com/jclM91b.png" alt="configure-img2" width="100%" />
            <li>
              Once it is done, you can close the Zadig tool and the browser will be able to
              communicate with the Posiflex thermal printer.
            </li>
          </ul>
        ),
      };
    }
    if (connectionType === "Serial Port") {
      return {
        value: "posiflex-serial",
        label: "Serial port",
        printer: "Posiflex",
        instructions: (
          <ul>
            <li>Connect the printer to the serial port of the POSIFLEX terminal</li>
          </ul>
        ),
      };
    }
  }
  if (urlName === "thermal-tvs") {
    if (connectionType === "USB") {
      return {
        value: "tvs-usb",
        label: "USB port",
        printer: "TVS",
        instructions: (
          <ul>
            <li>Connect the printer to the USB port of the TVS terminal</li>
            <li>
              Install Zadig from this{" "}
              <a
                href="https://github.com/pbatard/libwdi/releases/download/v1.5.0/zadig-2.8.exe"
                target="_blank"
                rel="noopener noreferrer"
              >
                link
              </a>
            </li>
            <li>Open the application. From Options -&gt; List All Devices</li>
            <img src="https://i.imgur.com/YSHxVZQ.png" alt="configure-img1" width="100%" />
            <li>
              From the list, identify your printer. Make sure &apos;WinUSB&apos; is selected from
              the target driver option below. Click Replace Driver.
            </li>
            <img src="https://i.imgur.com/jclM91b.png" alt="configure-img2" width="100%" />
            <li>
              Once it is done, you can close the Zadig tool and the browser will be able to
              communicate with the TVS thermal printer.
            </li>
          </ul>
        ),
      };
    }
    if (connectionType === "Serial Port") {
      return {
        value: "tvs-serial",
        label: "Serial port",
        printer: "TVS",
        instructions: (
          <ul>
            <li>Connect the printer to the serial port of the TVS terminal</li>
          </ul>
        ),
      };
    }
  }
  if (urlName === "thermal-shreyans" && connectionType === "Bluetooth") {
    return {
      value: "shreyans-bluetooth",
      label: "Bluetooth",
      printer: "Shreyans",
      instructions: (
        <ul>
          <li>
            Ensure your laptop&apos;s Bluetooth is turned on, but do not connect to bluetooth from
            there.
          </li>
          <li>
            Select &quot;Bluetooth&quot; from the dropdown menu above, then click the
            &quot;Select&quot; button below.
          </li>
          <li>When printing in Chrome, choose &quot;MPT-II&quot; from the pop-up options.</li>
        </ul>
      ),
    };
  }
  if (urlName === "tvs-label-printer" && connectionType === "USB") {
    return {
      value: "tvs-label-usb",
      label: "USB port",
      printer: "TVS-LP46",
      instructions: (
        <ul>
          <li>Connect the TVS LP 46 LITE to the USB port of your device</li>
          <li>
            Install Zadig from this{" "}
            <a
              href="https://github.com/pbatard/libwdi/releases/download/v1.5.0/zadig-2.8.exe"
              target="_blank"
              rel="noopener noreferrer"
            >
              link
            </a>
          </li>
          <li>Open the application. From Options &rarr; List All Devices</li>
          <img src="https://i.imgur.com/YSHxVZQ.png" alt="configure-img1" width="100%" />
          <li>
            From the list, find <strong>&quot;USB Printing Support&quot;</strong> or{" "}
            <strong>&quot;Bar Code Printer TT065-50&quot;</strong>. Make sure{" "}
            <strong>WinUSB (Microsoft)</strong> is selected as the target driver, then click{" "}
            <strong>Replace Driver</strong>.
          </li>
          <img src="https://i.imgur.com/jclM91b.png" alt="configure-img2" width="100%" />
          <li>
            Once done, close Zadig. The browser will now be able to communicate with the TVS LP 46
            LITE label printer via WebUSB.
          </li>
          <li>
            Go to <strong>Printer Configuration</strong> in settings and click{" "}
            <strong>Test Label Print</strong> to verify the connection.
          </li>
        </ul>
      ),
    };
  }
  if (urlName === "weighing-scale" && connectionType === "USB") {
    return {
      value: "weighing-scale",
      label: "Usb port",
      printer: "Prrestige",
      instructions: (
        <ul>
          <li>Keep the usb of weighing device connected to the laptop</li>
          <li>When adding a weighing product, a pop up will appear for the first time</li>
          <li>Select your weighing scale from there, pair it and the weight will be populated</li>
        </ul>
      ),
    };
  }
  return null;
};

export const Peripherals = () => {
  const showSnackbar = useSnackbar();
  const isMobile = useGetDevice();
  const { color } = useContext(UserContext);
  const { printUSB } = usePrint();
  const { findWeighingItem, renderWeighingModal } = useWeighingItemModal();

  const dispatch = useDispatch();
  const deviceType = useSelector(getDeviceType);
  const [connect, setConnect] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [Open, setOpen] = useState(false);
  const navigate = useNavigate();
  const managerNumber = useSelector(getmangeruidx);
  const mangerPin = useSelector(getmangerPin);
  const contextId = localStorage.getItem("locId");
  const [isVisible, setVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
  const [scaleConfig, setScaleConfig] = useState(JSON.parse(localStorage.getItem("scaleConfig")));
  const [autoConnect, setAutoConnect] = useState(true);
  const [heartbeat, setHeartbeat] = useState(true);
  const toggle = () => {
    setVisible(!isVisible);
  };

  const [printerConfig, setPrinterConfig] = useState(
    JSON.parse(localStorage.getItem("printerConfig"))
  );

  const [setupModalOpen, setSetupModalOpen] = useState(false);
  const [modalManufacturer, setModalManufacturer] = useState(null);
  const [modalConnectionType, setModalConnectionType] = useState(null);
  const [modalManufacturerOptions, setModalManufacturerOptions] = useState([]);
  const [showInstructions, setShowInstructions] = useState(false);

  const handleConnect = () => {
    setConnect(true);
  };

  const isLabelPrinterEnabled =
    localStorage.getItem("retailType") !== "GROCERY" &&
    JSON.parse(localStorage.getItem("appConfig") || "{}")?.all?.LABEL_PRINTER?.flag === true;

  const getSingleManufacturerOptions = () => {
    const opts = [
      { value: "thermal-shreyans", label: "Shreyans" },
      { value: "weighing-scale", label: "Weighing Scale" },
    ];
    if (isLabelPrinterEnabled) {
      opts.push({ value: "tvs-label-printer", label: "TVS Label Printer" });
    }
    return opts;
  };

  const handleSetupClick = (device) => {
    if (device?.urlName === "thermal-printer") {
      const thermalOptions = [
        { value: "thermal-posiflex", label: "Posiflex" },
        { value: "thermal-tvs", label: "TVS" },
      ];
      let preMfg = null;
      let preConn = null;
      if (printerConfig?.printer === "Posiflex") {
        preMfg = thermalOptions[0];
        preConn = printerConfig?.value === "posiflex-serial" ? "Serial Port" : "USB";
      } else if (printerConfig?.printer === "TVS") {
        preMfg = thermalOptions[1];
        preConn = printerConfig?.value === "tvs-serial" ? "Serial Port" : "USB";
      }
      setModalManufacturerOptions(thermalOptions);
      setModalManufacturer(preMfg);
      setModalConnectionType(preConn);
    } else {
      const allOpts = getSingleManufacturerOptions();
      const mfg = allOpts.find((opt) => opt.value === device?.urlName) || null;
      const types = mfg ? getConnectionTypes(mfg.value) : [];
      setModalManufacturerOptions(mfg ? [mfg] : []);
      setModalManufacturer(mfg);
      setModalConnectionType(types.length === 1 ? types[0] : null);
    }
    setSetupModalOpen(true);
  };

  const handleCloseSetupModal = () => {
    setSetupModalOpen(false);
    setModalManufacturer(null);
    setModalConnectionType(null);
    setModalManufacturerOptions([]);
    setShowInstructions(false);
  };

  const handleConnectDevice = () => {
    if (!modalManufacturer || !modalConnectionType) return;
    const configOption = getConfigOption(modalManufacturer.value, modalConnectionType);
    if (!configOption) return;

    if (configOption.value === "weighing-scale") {
      localStorage.setItem("scaleConfig", JSON.stringify(configOption));
      setScaleConfig(configOption);
    } else if (configOption.printer === "TVS-LP46") {
      localStorage.setItem("labelPrinterConfig", JSON.stringify(configOption));
    } else {
      localStorage.setItem("printerConfig", JSON.stringify(configOption));
      if (deviceType === "android") {
        emit({ type: "localData", data: { printerConfig: configOption } });
        if (configOption?.label === "Bluetooth") {
          emit({ type: "connectPeripheral", data: { printerConfig: configOption } });
        }
      }
      setPrinterConfig(configOption);
    }

    handleCloseSetupModal();
  };

  const handleTestPrint = () => {
    const orgConfig = JSON.parse(localStorage.getItem("orgConfig") || "{}");
    const templateId = orgConfig?.templateId;
    const charsPerLine = orgConfig?.charactersPerLine ?? 42;
    printUSB(false, true, templateId, Number(charsPerLine));
  };

  const filteredAppnames = AppList.filter((app) => {
    if (app.urlName === "tvs-label-printer" && !isLabelPrinterEnabled) return false;
    const appNameMatches = app.name.toLowerCase().includes(searchQuery.toLowerCase());
    const categoryMatches =
      selectedCategory === "All" ||
      (app.category && app.category.some((category) => selectedCategory.includes(category)));
    return appNameMatches && categoryMatches;
  });

  const [managerDetails, setManagerDetails] = useState([{}]);

  useEffect(() => {
    const payload = { contextId };
    getManagers(payload).then((res) => {
      const response = res?.data?.data?.map((e) => {
        return {
          value: e?.mobile_number,
          label: e?.first_name,
        };
      });
      setManagerDetails(response);
    });
  }, []);

  const [managerModal, setmanagerModal] = useState(false);

  const handleOffline = () => {
    setmanagerModal(true);
  };

  const handleProceedOffline = () => {
    setLoader(true);
    let managerpayload = {
      mobile: managerNumber,
      primaryPassword: mangerPin,
    };
    validateManagerPin(managerpayload)
      .then((res) => {
        showSnackbar("Success pin verified", "success");
        setLoader(false);
        localStorage.setItem("storeMode", "OFFLINE");
        setmanagerModal(false);
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setLoader(false);
        setmanagerModal(false);
      });
  };

  const handleClose = () => {
    setmanagerModal(false);
  };

  const handleKeyPress = (event) => {
    if (
      event.key === "Enter" &&
      selectedItemIndex >= 0 &&
      selectedItemIndex < filteredAppnames.length
    ) {
      handleSetupClick(filteredAppnames[selectedItemIndex]);
    } else if (event.key === "ArrowLeft") {
      if (selectedItemIndex >= 0) {
        setSelectedItemIndex(selectedItemIndex - 1);
      }
    } else if (event.key === "ArrowRight") {
      if (selectedItemIndex <= filteredAppnames.length - 1) {
        setSelectedItemIndex(selectedItemIndex + 1);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [selectedItemIndex, filteredAppnames]);

  return (
    <>
      {renderWeighingModal()}

      {setupModalOpen && (
        <div className="periph-modal-overlay" onClick={handleCloseSetupModal}>
          <div
            className="periph-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="periph-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="periph-modal-header">
              <h2 id="periph-modal-title" className="periph-modal-title">
                Setup Device
              </h2>
              <button
                className="periph-modal-close-btn"
                type="button"
                aria-label="Close"
                onClick={handleCloseSetupModal}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M18 6 6 18"></path>
                  <path d="m6 6 12 12"></path>
                </svg>
              </button>
            </div>

            <div className="periph-modal-body">
              <div className="periph-modal-field">
                <label className="periph-modal-label">Manufacturer</label>
                <SoftSelect
                  options={modalManufacturerOptions}
                  placeholder="Select manufacturer"
                  value={modalManufacturer}
                  onChange={(opt) => {
                    setModalManufacturer(opt);
                    const types = getConnectionTypes(opt.value);
                    setModalConnectionType(types.length === 1 ? types[0] : null);
                  }}
                />
              </div>

              {modalManufacturer && (
                <div className="periph-modal-field">
                  <div
                    className="periph-modal-label-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <label className="periph-modal-label" style={{ margin: 0 }}>
                      Connection Type
                    </label>
                    <button
                      type="button"
                      className="periph-view-more-btn"
                      onClick={() => setShowInstructions(true)}
                    >
                      View More
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginLeft: "2px" }}
                      >
                        <path d="m9 18 6-6-6-6" />
                      </svg>
                    </button>
                  </div>
                  <div className="periph-conn-type-grid">
                    {["USB", "Serial Port", "Bluetooth"].map((connType) => {
                      const enabled = getConnectionTypes(modalManufacturer?.value).includes(
                        connType
                      );
                      return (
                        <button
                          key={connType}
                          type="button"
                          className={`periph-conn-type-btn${
                            modalConnectionType === connType ? " active" : ""
                          }`}
                          disabled={!enabled}
                          onClick={() => setModalConnectionType(connType)}
                        >
                          <ConnectionTypeIcon type={connType} />
                          <span className="periph-conn-type-label">{connType}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              {showInstructions &&
                modalManufacturer &&
                modalConnectionType &&
                getConfigOption(modalManufacturer?.value, modalConnectionType) && (
                  <div className="periph-modal-instructions">
                    <h3 className="periph-modal-instructions-title">Instructions</h3>
                    <div className="periph-modal-instructions-content">
                      {getConfigOption(modalManufacturer?.value, modalConnectionType).instructions}
                    </div>
                  </div>
                )}

              <div className="periph-modal-actions">
                <button
                  type="button"
                  className="periph-modal-cancel-btn"
                  onClick={handleCloseSetupModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="periph-modal-connect-btn"
                  disabled={!modalManufacturer || !modalConnectionType}
                  onClick={handleConnectDevice}
                >
                  Connect Device
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Navbar>
        <div className="peripherals-page-container">
          <div className="peripherals-header">
            <div className="peripherals-header-content">
              <div className="peripherals-header-left">
                <button
                  className="peripherals-back-btn"
                  onClick={() => navigate("/products/operations-menu")}
                  type="button"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-left w-5 h-5 text-slate-600"
                    aria-hidden="true"
                  >
                    <path d="m12 19-7-7 7-7"></path>
                    <path d="M19 12H5"></path>
                  </svg>
                </button>
                <h1 className="peripherals-title">Peripherals Management</h1>
              </div>
              <button
                className="peripherals-scan-btn"
                type="button"
                onClick={() => showSnackbar("Feature coming soon", "info")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-refresh-cw"
                  aria-hidden="true"
                >
                  <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
                  <path d="M21 3v5h-5"></path>
                  <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
                  <path d="M8 16H3v5"></path>
                </svg>
                Scan Devices
              </button>
            </div>
          </div>

          <div className="peripherals-main">
            <div className="peripherals-grid">
              {filteredAppnames?.map((e, i) => {
                const PRINTER_CONNECTED = Array.isArray(e?.device)
                  ? e?.device?.includes(printerConfig?.printer)
                  : printerConfig?.printer === e?.device || scaleConfig?.printer === e?.device;

                return (
                  <div
                    key={i}
                    className={`peripherals-card ${i === selectedItemIndex ? "active" : ""}`}
                  >
                    <div className="peripherals-card-top">
                      <div className="peripherals-card-header-row">
                        <div
                          className={`peripherals-icon-box ${
                            PRINTER_CONNECTED ? "connected" : "disconnected"
                          }`}
                        >
                          {getDeviceIcon(e)}
                        </div>
                        {(e?.category?.includes("Cash Drawer") ||
                          e?.category?.includes("EDC Terminal")) && (
                          <button
                            type="button"
                            role="switch"
                            aria-checked={false}
                            data-state="unchecked"
                            className="periph-switch-btn"
                            onClick={() => showSnackbar("Feature coming soon", "info")}
                          >
                            <span
                              data-state="unchecked"
                              className="periph-switch-thumb"
                            />
                          </button>
                        )}
                      </div>
                      <h3 className="peripherals-card-title">{e?.name}</h3>
                      <p className="peripherals-card-model">
                        {Array.isArray(e?.device) && e?.models
                          ? e?.models[printerConfig?.printer] || e?.model
                          : e?.model}
                      </p>
                    </div>

                    <div className="peripherals-card-bottom">
                      <div className="peripherals-status-row">
                        {PRINTER_CONNECTED ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="status-icon connected"
                            aria-hidden="true"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="m9 12 2 2 4-4"></path>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="status-icon disconnected"
                            aria-hidden="true"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="m15 9-6 6"></path>
                            <path d="m9 9 6 6"></path>
                          </svg>
                        )}
                        <span
                          className={`peripherals-status-text ${
                            PRINTER_CONNECTED ? "connected" : "disconnected"
                          }`}
                        >
                          {PRINTER_CONNECTED ? "Connected" : "Disconnected"}
                        </span>
                      </div>
                      <div className="peripherals-last-active">
                        Last active: {PRINTER_CONNECTED ? "Just now" : "Offline"}
                      </div>
                      <div className="peripherals-card-actions">
                        <button
                          className="peripherals-setup-btn"
                          type="button"
                          disabled={
                            e?.category?.includes("Cash Drawer") ||
                            e?.category?.includes("EDC Terminal")
                          }
                          onClick={() => handleSetupClick(e)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-settings-2"
                            aria-hidden="true"
                          >
                            <path d="M14 17H5"></path>
                            <path d="M19 7h-9"></path>
                            <circle cx="17" cy="17" r="3"></circle>
                            <circle cx="7" cy="7" r="3"></circle>
                          </svg>
                          Setup
                        </button>
                        <button
                          className="peripherals-test-btn"
                          type="button"
                          disabled={
                            !PRINTER_CONNECTED ||
                            !(
                              (Array.isArray(e?.device)
                                ? e?.device.some((d) => d === "Posiflex" || d === "TVS")
                                : e?.device === "Posiflex" || e?.device === "TVS") ||
                              e?.category?.includes("Weighing Scale") ||
                              e?.category?.includes("Thermal Printer")
                            )
                          }
                          onClick={() => {
                            if (e?.category?.includes("Weighing Scale")) {
                              findWeighingItem("", "Weighing Scale Test", "weighingscale", "gms");
                            } else {
                              handleTestPrint();
                            }
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-refresh-cw"
                            aria-hidden="true"
                          >
                            <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
                            <path d="M21 3v5h-5"></path>
                            <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
                            <path d="M8 16H3v5"></path>
                          </svg>
                          Test
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="periph-adv-settings-box">
              <div className="periph-adv-settings-header">
                <div className="periph-adv-settings-icon-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-settings-2 w-5 h-5"
                    aria-hidden="true"
                  >
                    <path d="M14 17H5" />
                    <path d="M19 7h-9" />
                    <circle cx="17" cy="17" r="3" />
                    <circle cx="7" cy="7" r="3" />
                  </svg>
                </div>
                <div className="periph-adv-settings-title-container">
                  <h2 className="periph-adv-settings-title">Advanced Settings</h2>
                  <p className="periph-adv-settings-subtitle">Manage global peripheral behaviors</p>
                </div>
              </div>
              <div className="periph-adv-settings-content">
                <div className="periph-adv-settings-row">
                  <div className="periph-adv-settings-info">
                    <h4 className="periph-adv-settings-item-title">Auto-connect Devices</h4>
                    <p className="periph-adv-settings-item-desc">
                      Automatically connect to known devices when the POS application starts.
                    </p>
                  </div>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={autoConnect}
                    data-state={autoConnect ? "checked" : "unchecked"}
                    className="periph-switch-btn"
                    onClick={() => showSnackbar("Feature is coming soon", "info")}
                  >
                    <span
                      data-state={autoConnect ? "checked" : "unchecked"}
                      className="periph-switch-thumb"
                    />
                  </button>
                </div>
                <div className="periph-adv-settings-row">
                  <div className="periph-adv-settings-info">
                    <h4 className="periph-adv-settings-item-title">Heartbeat Check</h4>
                    <p className="periph-adv-settings-item-desc">
                      Ping connected devices every 30 seconds to verify connection stability.
                    </p>
                  </div>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={heartbeat}
                    data-state={heartbeat ? "checked" : "unchecked"}
                    className="periph-switch-btn"
                    onClick={() => showSnackbar("Feature is coming soon", "info")}
                  >
                    <span
                      data-state={heartbeat ? "checked" : "unchecked"}
                      className="periph-switch-thumb"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
};
